import React, { useState } from 'react';

interface GenerateUrlProps {
    isGeneratingUrl: boolean;
    handleGenerateUrl: () => void;
    deploymentUrl: string | null;
}

const GenerateUrl: React.FC<GenerateUrlProps> = ({ isGeneratingUrl, handleGenerateUrl, deploymentUrl }) => {
  
    const [activeSection, setActiveSection] = useState<string | null>(null);

    const toggleSection = (section: string) => {
        setActiveSection(activeSection === section ? null : section);
    };
    return (
        <div className="generate-url-section">
            <div className="accordion-item">
                <h3 onClick={() => toggleSection('url')}>Generar URL</h3>
                {activeSection === 'url' && (
                    <div className="accordion-content">
                        <button onClick={handleGenerateUrl} disabled={isGeneratingUrl}>
                            {isGeneratingUrl ? 'Generando URL...' : 'Generar URL'}
                        </button>
                        {deploymentUrl && (
                            <div className="deployment-url">
                                <a href={deploymentUrl} target="_blank" rel="noopener noreferrer">
                                    {deploymentUrl}
                                </a>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default GenerateUrl;
